<template>
  <!-- eslint-disable -->
  <div class="container">
    <a-table class="table" :columns="columns" :loading="loading" :dataSource="tableData" rowKey="id" :pagination="false">
      <template v-slot:reason="text">
        <clamp :text="text"> </clamp>
      </template>

      <template v-slot:resource="text, record">
        <v-clamp autoresize :max-lines="2" class="clamp-container">
          <template>
            {{ text }}
          </template>

          <template v-slot:after="{ toggle, expanded, clamped }">
            <template>
              <template v-if="expanded || !clamped">
                <a class="link-button" :href="annex.value" v-for="annex in record.annexList" :key="annex.key">{{ annex.key }}</a>
              </template>
              <a-button v-if="expanded || clamped" type="link" class="link" @click="toggle">{{ expanded ? '收起' : '展开' }}</a-button>
            </template>
          </template>
        </v-clamp>
      </template>

      <template v-slot:status="status, record">
        <v-clamp autoresize :max-lines="2" class="clamp-container feedback-text">
          <template>
            {{ feedbackText(record) }}
          </template>
          <template v-slot:after="{ toggle, expanded, clamped }">
            <a-button v-if="expanded || clamped" type="link" class="link" @click="toggle">{{ expanded ? '收起' : '展开' }}</a-button>
          </template>
        </v-clamp>
      </template>
      <template v-slot:action="text, record">
        <template v-if="record.status === 0">
          <a-button size="small" class="action-button" @click="commitProgress({ id: record.id, status: 2 })">感兴趣</a-button>
          <a-button size="small" class="action-button" @click="commitProgress({ id: record.id, status: 1 })">不感兴趣</a-button>
        </template>
        <template v-if="record.status === 2 || record.status === 3">
          <a-button size="small" class="action-button" @click="openModal(record)">沟通记录</a-button>
          <!-- <a-button size="small" class="action-button" @click="commitProgress({id: record.id, status: 1})" >不感兴趣</a-button> -->
        </template>
      </template>
    </a-table>
    <div class="footer" v-if="pageInfo.total > pageInfo.pageSize">
      <a-pagination :current="pageInfo.page" :total="pageInfo.total" :pageSize="pageInfo.pageSize" @change="onChange" :show-total="total => `共${total}项`" />
    </div>
    <a-modal 
      v-model="modal.visible" 
      title="沟通记录" @ok="modalOk" 
      @cancel="modalCancel"
      :ok-button-props="{ props: { loading: modal.loading } }"
    >
      <a-row class="" :gutter="[8, 8]">
        <a-col :span="4" class="model-label">进展:</a-col>
        <a-col :span="20">
          <a-radio-group v-model="modal.radioValue" button-style="solid">
            <a-radio-button value="chat1">
              一聊
            </a-radio-button>
            <a-radio-button value="chat2">
              二聊
            </a-radio-button>
            <a-radio-button value="chat3">
              多次聊
            </a-radio-button>
            <a-radio-button value="chat4">
              立项
            </a-radio-button>
          </a-radio-group>
        </a-col>
      </a-row>
      <a-row class="" :gutter="[8, 8]">
        <a-col :span="4" class="model-label">进展说明:</a-col>
        <a-col :span="20">
          <a-textarea :auto-size="{ minRows: 3, maxRows: 6 }" v-model="modal.dataInfo[modal.radioValue]"></a-textarea>
        </a-col>
      </a-row>
      <a-row class></a-row>
    </a-modal>
  </div>
</template>
<script>
import Clamp from '../clamp';
import VClamp from 'vue-clamp';
import { toMeList, commitProgress } from '@/api/humint';
import moment from 'moment';
import { getStatusLabel } from './constants.js';

export default {
  components: {
    Clamp,
    VClamp
  },
  data() {
    const columns = [
      {
        title: '推荐理由',
        dataIndex: 'reason',
        key: 'reason',
        scopedSlots: {
          customRender: 'reason'
        }
      },
      {
        title: '资源情况',
        dataIndex: 'resource',
        key: 'resource',
        scopedSlots: {
          customRender: 'resource'
        }
      },
      {
        title: '反馈情况',
        key: 'status',
        dataIndex: 'status',

        scopedSlots: {
          customRender: 'status'
        }
      },
      {
        title: '快捷操作',
        key: 'action',
        dataIndex: 'action',
        scopedSlots: {
          customRender: 'action'
        }
      }
    ];

    return {
      columns,
      modal: {
        visible: false,
        title: '',
        loading: false,
        radioValue: 'chat1',
        dataInfo: {
          id: undefined,
          chat1: '',
          chat2: '',
          chat3: '',
          chat4: '',
          originStatus: 0
        }
      },
      list: [],
      loading: false,
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  mounted() {
    this.query();
  },
  computed: {
    tableData() {
      return this.list.map(i => {
        try {
          let resource = JSON.parse(i.resource);
          i.resource = resource.tableRecordList
            .map(i => {
              return `${i.key}: ${Array.isArray(i.value) ? i.value.join(' ') : i.value}`;
            })
            .join(', ');
          i.annexList = resource.annexList;
        } catch (e) {
          console.log(e);
        }
        return i;
      });
    }
  },
  methods: {
    async query() {
      this.loading = true;
      let res = await toMeList({
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize
      }).finally(() => {
        this.loading = false;
      });
      if (res.code === 200) {
        this.list = res.data.list.map(i => {
          i.createAt = moment(i.createAt).format('YYYY/MM/DD');
          return i;
        });
        this.pageInfo.total = res.data.total;
      }
    },
    openModal(record) {
      this.modal.visible = true;
      this.modal.dataInfo = {
        id: record.id,
        chat1: record.chat1,
        chat2: record.chat2,
        chat3: record.chat3,
        originStatus: record.status,
        chat4: record.chat4
      };
    },
    modalInit() {
      this.modal.visible = false;
      this.modal.id = -1;
      this.modal.radioValue = 'chat1';
      this.modal.dataInfo.chat1 = '';
      this.modal.dataInfo.chat2 = '';
      this.modal.dataInfo.chat3 = '';
      this.modal.dataInfo.chat4 = '';
    },
    async modalOk() {

      let options = {
        
        chat1: this.modal.dataInfo.chat1,
        chat2: this.modal.dataInfo.chat2,
        chat3: this.modal.dataInfo.chat3,
        chat4: this.modal.dataInfo.chat4
      };
      let arrNum = Object.keys(options).filter(key => {
        return options[key];
      }).length;
      if(arrNum < 1) {
        this.$message.error('请填写进展说明');
        return;
      }
      if (options.chat4) {
        options.status = 3;
      }
      this.modal.loading = true;
      let res = await commitProgress({
        ...options,
        id: this.modal.dataInfo.id,
      }).finally(() => {
        this.modal.loading = false;
      });
      if (res.code === 200) {
        this.modalInit();
        this.query();
      }
    },
    modalCancel() {
      this.modalInit();
    },

    async commitProgress(options) {
      let res = await commitProgress(options);
      if (res.code === 200) {
        this.query();
      }
    },
    onChange(page, pageSize) {
      this.pageInfo.page = page;
      this.pageInfo.pageSize = pageSize;
      this.query();
    },
    feedbackText(item) {
      let status = item.status;
      let keys = [
        {
          key: 'chat4',
          value: '立项'
        },
        {
          key: 'chat3',
          value: '多聊'
        },
        {
          key: 'chat2',
          value: '二聊'
        },
        {
          key: 'chat1',
          value: '一聊'
        },
      ];
      let chatText = keys
        .filter(i => item[i.key])
        .map(key => {
          let text = item[key.key] || '';
          text = text.replace(/\n/g, ' ');
          return `${key.value}: ${text}`;
        })
        .join('\n');
      let text = `${getStatusLabel(status)}\n${chatText}`;

      return text;
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  margin: 10px 0;
  display: flex;
  justify-content: flex-end;
}
.clamp-container {
  @media only screen and (max-width: 800px) {
    max-width: 70px;
  }
  @media only screen and (min-width: 800px) {
    max-width: 300px;
  }
  .link {
    padding: 0 5px;
  }
}
.feedback-text {
  white-space: pre-line;
}
.action-button {
  margin: 3px;
}
.link-button {
  display: block;
}
.model-label {
  text-align: right;
}
/deep/ .ant-table-tbody > tr > td {
  @media only screen and (max-width: 800px) {
    padding: 10px 5px;
  }
}
</style>
